export default __webpack_public_path__ + "static/media/varmatie_logo.668d63aa.png";